import { schema } from 'normalizr';
import paginateAction from '@utils/paginateAction';
import getNewScheduleItem from '@models/ScheduleItem';
import { classTypes } from '../constants';
import { itemSchema, paginatorListSchema } from '../schemas';

export const fetchClassDetails = (uid) => ({
  type: classTypes.FETCH_CLASS,
  endpoint: `v1/uplus/classes/${uid}/details/`,
  method: 'get',
  uid,
  schema: new schema.Object({ item: itemSchema }),
  entityType: 'item',
  processData: (data) => {
    const newData = data;
    newData.programmeUid = newData.programme.uid || newData.collection.uid;
    newData.batch_group = newData.programme.batch_group;
    delete newData.programme;
    delete newData.collection;
    return newData;
  }
});

const getSimilarAndOtherCourses = (uid) => (next) => ({
  type: classTypes.FETCH_SIMILAR_AND_OTHER_COURSES,
  endpoint: next,
  method: 'get',
  key: uid,
  resetWithoutEmpty: false,
  schema: paginatorListSchema,
  directPaginatedEntity: true,
  entityType: 'feedrow',
  processData: (data) => {
    const newData = data;
    newData.results = newData.results.map((resultItem) => ({
      ...resultItem,
      key: uid,
      data: resultItem.data.map((dataRow) => ({
        ...dataRow,
        ...dataRow.programme
      }))
    }));
    return newData;
  }
});

export const fetchSimilarAndOtherCourses = (uid) =>
  paginateAction(
    `v1/search_v3/special_classes/${uid}/v2/`,
    getSimilarAndOtherCourses(uid),
    'similarAndOtherCourses',
    uid,
    false
  )(false);

export const sendFreeVideoWatched = (uid) => ({
  type: classTypes.SEND_WATCHED,
  endpoint: `v1/post/${uid}/watched/`,
  method: 'post',
  uid
});

export const updateView = (uid) => ({
  type: classTypes.UPDATE_PAGEVIEW,
  endpoint: `v1/analytics/post/${uid}/`,
  method: 'post',
  uid
});

export const fetchScheduledClasses = (
  goalUid,
  url = '',
  direction,
  resetWithoutEmpty = false
) => ({
  type: classTypes.FETCH_SCHEDULED_CLASSES,
  endpoint: url,
  method: 'get',
  key: goalUid,
  schema: {},
  direction,
  resetWithoutEmpty,
  processData: (paginatedObject) => {
    return {
      ...paginatedObject,
      results: paginatedObject.results.map((item) => getNewScheduleItem(item))
    };
  }
});

export const fetchLearnerCalendarData = (goalUid, time, key) => ({
  type: classTypes.FETCH_CALENDAR_DATA,
  endpoint: `v1/uplus/subscription/count/?goal_uid=${goalUid}&epoch_time=${Math.round(
    time / 1000
  )}&timezone_difference=330&version=3`,
  method: 'get',
  key,
  goalUid
});
